<template>
  <role-index title="Roles de Administradores" admin />
</template>

<script>
import RoleIndex from '../RoleIndex'
export default {
  components: { RoleIndex }
}
</script>

<style></style>
